import { render, staticRenderFns } from "./CrashBetElement.vue?vue&type=template&id=e0ce38d8&scoped=true"
import script from "./CrashBetElement.vue?vue&type=script&lang=js"
export * from "./CrashBetElement.vue?vue&type=script&lang=js"
import style0 from "./CrashBetElement.vue?vue&type=style&index=0&id=e0ce38d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ce38d8",
  null
  
)

export default component.exports